import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrearPedidoDTO } from 'src/app/main/backoffice/modules/pedidos/models/crearPedido.dto';

@Component({
  selector: 'app-pedido-confirmado-dialog-component',
  templateUrl: './pedido-confirmado-dialog-component.component.html',
  styleUrls: ['./pedido-confirmado-dialog-component.component.scss'],
})
export class PedidoConfirmadoDialogComponentComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<PedidoConfirmadoDialogComponentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { pedido: CrearPedidoDTO; carrito: any[] },
  ) {
    console.log(data);
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    console.log(this.data);
  }

  enviarWhatsApp(): void {
    const mensaje = this.construirMensaje();
    const telefonoNegocio = '5493364181499';

    const url = `https://wa.me/${telefonoNegocio}?text=${encodeURIComponent(mensaje)}`;

    window.open(url, '_blank');

    this.dialogRef.close();
  }

  private construirMensaje(): string {
    const pedido = this.data.pedido;
    const carrito = this.data.carrito;

    const tipoEntrega =
      pedido.deliveryType === 2 ? 'Delivery' : 'Retiro en local';

    let mensaje = `🍔 *NUEVO PEDIDO* 🍔\n\n`;
    mensaje += `👤 Cliente: ${pedido.customerName}\n`;
    mensaje += `📞 Teléfono: ${pedido.customerPhone}\n`;
    mensaje += `🚚 Tipo: ${tipoEntrega}\n`;

    if (pedido.deliveryAddress) {
      mensaje += `📍 Dirección: ${pedido.deliveryAddress}\n`;
    }

    if (pedido.deliveryNotes) {
      mensaje += `📝 Notas: ${pedido.deliveryNotes}\n`;
    }

    mensaje += `\n🛒 *Detalle del pedido:*\n`;

    carrito.forEach((item, index) => {
      mensaje += `\n${index + 1}) *${item.nombre}* x${item.cantidad}\n`;
      mensaje += `   💲 $${item.total}\n`;

      if (item.extras?.length) {
        mensaje += `   ➕ Extras:\n`;
        item.extras.forEach((extra: any) => {
          mensaje += `      • ${extra.name} (+$${extra.price})\n`;
        });
      }
    });

    const totalGeneral = carrito.reduce((acc, item) => acc + item.total, 0);

    mensaje += `\n💰 *TOTAL: $${totalGeneral}*\n`;

    return mensaje;
  }
}
